var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #c0272d;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,490.7c-130.1,0-234.7-104.5-234.7-234.7S125.9,21.3,256,21.3s234.7,104.5,234.7,234.7-104.5,234.7-234.7,234.7ZM256,64c-106.7,0-192,85.3-192,192s85.3,192,192,192,192-85.3,192-192-85.3-192-192-192Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.7,224c-12.8,0-21.3-8.5-21.3-21.3v-10.7c0-12.8,8.5-21.3,21.3-21.3s21.3,8.5,21.3,21.3v10.7c0,12.8-8.5,21.3-21.3,21.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.3,224c-12.8,0-21.3-8.5-21.3-21.3v-10.7c0-12.8,8.5-21.3,21.3-21.3s21.3,8.5,21.3,21.3v10.7c0,12.8-8.5,21.3-21.3,21.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.7,352c-8.5,0-14.9-4.3-19.2-10.7,0-2.1-17.1-32-55.5-32s-55.5,29.9-55.5,32c-6.4,10.7-19.2,14.9-27.7,8.5-10.7-6.4-14.9-17.1-8.5-27.7,2.1-2.1,27.7-55.5,93.9-55.5s91.7,51.2,93.9,55.5c4.3,10.7,0,23.5-8.5,27.7-6.4,2.1-8.5,2.1-12.8,2.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBad);
export default __webpack_public_path__ + "static/media/bad.6461c38a72d59e670c6451510a4000e4.svg";
export { ForwardRef as ReactComponent };